export const TEXTAREA_MAX_ROWS = 7;
export const ORGANIZATION_DEVICES_MAX_ROWS = 3;
export const ORGANIZATION_USERS_MAX_ROWS = 3;
export const INVOICE_NUMBER_MAX_LENGTH = 14;
export const ORDER_DEVICES_MIN_VALUE = 1;
export const CHART_MIN_VALUE = 60;
export const CHART_MAX_VALUE = 150;
export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
